import React, { useLayoutEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';

import animA from '../animations/animA';
import { img_office, people_daouda2, svg_ensemble, img_contactca, img_brands } from '../assets';
import { useDisplayValue, useMouse } from '../hooks/hooks';

import { project, servicesList } from '../data/data';
import { c_hero, c_tag } from '../data/copy';

import Portfolio from '../components/Portfolio';
import Page from '../components/containers/Page';
import Section from '../components/containers/Section';
import ImageMedia from '../components/common/ImageMedia';
import { Logo, MotionContent } from '../components/imports';
// import MoveAround from '../components/containers/MoveAround';
// import { DefisReleves } from '../components/DefisReleves';
import SlidingContent from '../components/common/SlidingContent';
import Capabilities from './Capabilities';



const Home = () => {
  document.title = `LAWWD® —  Dakar, Senegal `

  return (
    <Page>
      {/* <Landing /> */}
      <LandingHero />
      {/* <Landing2 /> */}

      {/* <WorldMap /> */}
      <FoundersWords />
      <Capabilities />
      <Stats />
      <Portfolio prev />
      {/* <DefisReleves /> */}
      <Brands />
      <LetsWork />
      {/* <div className='flex bg-slate-200 h-[40vh]' /> */}
    </Page>
  )
}

const LandingHero = () => {

  // const landingRef = useRef(null);
  // const { H } = useWindowSize();
  // const imgRef = useRef(null);
  // const [container, setContainer] = useState(null);

  /* useEffect(() => {
    const containerElement = document.getElementById('LandingHero');
    if (containerElement) {
      setContainer(containerElement);
    }
  }, []); */

  /*   const { scrollYProgress } = useScroll({
      container: container,
      target: imgRef,
      offset: ["start start", "end end"]
    }); */

  // const translateY = useTransform(scrollYProgress, [0, 1], [-H / 2, H / 4]);

  return (
    <section id="LandingHero"
      // style={{ height: "200vh" }}
      // ref={imgRef}
      className="relative w-full overflow-clip flex flex-col items-start pointer-events-auto justify-start bg-dark"
    >
      {/* <MoveAround offsetValue={50} > */}
      {/*  <ImageMedia
          bypass
          src={require('../assets/images/bg.avif')}
          className="z-[2] !pointer-events-auto =active:!pointer-events-none !select-none !absolute top-[-20vh] inset-x-0 mx-auto bg-cover h-[200vh] lg:h-[200vh] object-bottom w-full object-cover lg:scale-[120%] -hue-rotate-15 delay-700 saturate-150 flex animate-slowfade"
          alt="bg"
        /> */}
      {/* </MoveAround > */}

      <Hero prev />

    </section>
  )
};

const Hero = ({ prev }) => {

  const textRef = useRef(null);
  // const viewInsights = useInsightsModal();

  /*  const showEmpreinte = () => {
     viewInsights.onOpen("empreinte")
   } */



  return (
    <Section className='relative bg-transparent animate-slowfade delay-500 overflow-y-clip z-[2] !pointer-events-none'>
      <div style={{ clipPath: "inset(0%)" }} className='relative flexV w-full overflow-clip'>
        <div className='z-[1] flex flex-col w-full items-center justify-center h-fit pointer-events-none'>

          <div className='top-0 absolute inset-0 flex bg-gradient-to-t select-none touch-none pointer-events-none' />

          <div className='relative flex flex-col w-full h-fit '>
            <div className='relative resp  z-[3] flex flex-col gap-8 center font-maison'>
              {/* // ^ TODO FIND LAWWD MP3 ASSET */}
              <div id='lookatwhatwedid' className='relative w-full h-[100svh] flex flex-col items-center justify-center animate-slowfade'>


                <div className='flex absolute bottom-20 *:absolute *:top-0 *:left-0 w-40 min-h-12 scale-105 origin-top-left'>
                  <Logo className={"saturate-0 w-full invert brightness-[2] animate-pulse"} />
                  <Logo className={"saturate-0 w-full invert brightness-[1] mix-blend-screen"} />
                </div>

                {/* <MoveAround change> */}
                <h1 className='max-w-[25ch] max-md:text-4xl= text-balance leading-[110%] font-normal text-center !pointer-events-auto'>
                  {c_hero/*  + " " + c_tag */}
                </h1>
                <p className='mt-10 text-sm font-poppins whitespace-nowrap capitalize muted text-center w-fit mx-auto'>
                  {c_tag}
                  {/* sourced in senegal, served worldwide 🇸🇳 */}
                  {/* établi. Dakar, 2016 🇸🇳 */}
                  {/* <br /> */}
                  {/* RC 20185478SN */}
                </p>
                <h2 className='sr-only'>{project.title.long}</h2>
                {/* </MoveAround> */}


              </div>

              {/* <SlidingContent /> */}

              <div className='flex flex-col relative items-center justify-center h-fit lg:min-h-[720px] space-y-16 pb-16 mt-16 !pointer-events-auto'>
                <h2 id='descr' ref={textRef}
                  // style={{ opacity }}
                  // transition={{ ease, duration }}
                  className='*:inline max-w-[35ch] paddingY text-center text-pretty resp'>
                  <HomeDescr prev={prev} langFr />

                </h2>

                {/* // TODO : ENABLE WITH PAGE TO MAP */}
                {/*  <button  onClick={showEmpreinte} id="buttonUnderline2" className='flex items-center px-2 mt-20 py-2 relative group !pointer-events-auto lg:dim muted hover:unmute quicker hover:nodim'>
                  <h4>Notre empreinte sur le globe</h4>
                  <span className='flex center absolute my-auto right-0 translate-x-full rounded-full -rotate-45 quicker group-hover:translate-x-5'>
                    <i className='flex size-8 center ri-arrow-right-s-line -rotate-45' />
                  </span>
                  </button> */}

                <div className='hidden===lg: flex mx-auto lg:bottom-8 w-[100dvw] mix-blend-screen z-[4] items-center justify-start'>
                  <SlidingContent />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
};

const HomeDescr = ({ prev, langFr }) => {
  const { toDefault, toPointer } = useMouse();
  const [initCount, setInitCount] = useState(false);

  useLayoutEffect(() => {
    setTimeout(() => {
      setInitCount(true)
    }, 1000)
  }, [])

  /*   const { toPointer } = useMouse() */

  /* const [initCount, setInitCount] = useState(false)
  useLayoutEffect(() => {
    setTimeout(() => {
      setInitCount(true)
    }, 1000)
  }, []) */

  return (
    <>
      Nous&nbsp;
      <span>
        apportons depuis 2018 notre <Link to={"/expertise"} className='relative pointer-events-auto buttonUnderline' id="">expertise&nbsp;360°</Link>&nbsp;
        {!prev && (
          <>
            en
            <span className='*:inline-flex overflow-y-clip'>
              {servicesList.fr.map((service, i) => (
                <span key={service + i} onMouseEnter={toPointer} onMouseLeave={toDefault} className='inline-flex items-center pr-1 h-6 pointer-events-auto'>
                  <span id="" className='buttonUnderline relative whitespace-nowrap'>{service}</span>{i < servicesList.fr.length - 1 && ','}
                  {i === servicesList.fr.length - 2 && ' et '}
                </span>
              ))}
            </span>
          </>
        )
        }
        à une prestigieuse liste comptant plus de
      </span>&nbsp;
      <span className='relative inline-flex'>
        <span className='sr-only opacity-0 pointer-events-none select-none relative'>100</span>
        {initCount &&
          <CountUp start={1} end={100}
            duration='3'
            useEasing
            className='absolute inset-0 left-0 text-center origin-bottom scale-x-105= !mx-0 !px-0 '
          />
        }
      </span>
      &nbsp;marques particulièrement <span id='buttonUnderline' className='pointer-events-auto inline-flex relative'>chez Nous, au Sénégal</span>.
    </>
  )

};

const FoundersWords = () => {

  // const { ease, duration } = animA();

  /* const s = {
    title: "Mot du Fondateur"
  } */

  return (
    <div className='bg-dark w-full'>
      <div className='flex flex-col relative *:!text-blakk'>
        <motion.div
          // initial={{ opacity: 0 }}
          // whileInView={{ opacity: 100 }}
          // transition={{ ease, duration }}
          viewport={{ once: true }}
          className='absolute inset-0 bg-blue-500== bg-white animate-slowfade' />


        <div className='flex relative w-full flex-col lg:flex-row'>
          <div className='DESK h-[100vh] sticky top-0 saturate-0 brightness-200 overflow-clip w-[50vw]'>
            <MotionContent height={"h-[100%]"} translateRange={["10%", "-20%"]} scaleRange={[1.1, 1.2]} >
              <ImageMedia src={people_daouda2} className="sticky top-0 h-[105%] origin-top object-cover object-right full scale-[105%]" />
            </MotionContent>
          </div>
          <div className='resp paddingY w-full mt-8 py-16'>
            <div className='relative flex flex-col items-start justify-start w-full lg:w-fit gap-8 mx-auto'>

              <div className='flex relative max-md:mx-auto'>

                <div className='MOB rounded-full overflow-hidden'>
                  <MotionContent height={"h-[100%]"} className={"!size-56 !aspect-square saturate-0 brightness-200 !rounded-full center"} translateRange={["10%", "-20%"]} scaleRange={[1.1, 1.2]} >
                    <ImageMedia src={people_daouda2} className="full scale-x-[105%] scale-y-[105%]" />
                  </MotionContent>
                </div>
                <div className='!aspect-square fit max-lg:absolute max-lg:bottom-0 max-lg:left-0 flex center relative bg-gradient-to-tr from-primary to-red-600 rounded-full'>
                  <ImageMedia bypass src={require('../assets/branding/L.png')} className="object-contain relative aspect-square size-8 invert m-6 " />
                </div>
              </div>
              {/* FOUNDERS MESSAGE */}
              <h4 className='w-full flex flex-col text-balance font-poppins pointer-events-none select-none'>
                {/*   <span className='maxW2'>
                  LAWWD est bien plus qu’une agence de branding – c’est une vision, un état d’esprit, une manière de repousser les limites de la créativité, une volonté de créer de la valeur, Chez Soi et au delà "Look At What We Did", ce n’est pas seulement un nom, c’est une promesse: celle de livrer un travail dont nous sommes fiers, qui marque les esprits et qui place nos clients au sommet.
                  <br /> <br />
                  Dès le premier jour, notre ambition a été claire: transformer les idées en expériences visuelles puissantes. Que ce soit à travers une identité de marque cohérente, des visuels 3D immersifs ou du contenu digital stratégique, nous donnons vie à des concepts qui résonnent, qui engagent et qui convertissent.</span>
                <br />

                <span className='maxW2'>
                  Nous croyons en l’impact du design bien pensé, du storytelling authentique et de l’innovation. Nous croyons surtout aux collaborations qui font la différence. Chaque projet est une opportunité d’aller plus loin, d’expérimenter, de créer quelque chose d’unique.
                  <br /> <br />
                  Si vous cherchez un partenaire capable de donner à votre marque une identité forte, une présence mémorable et un univers qui lui est propre, vous êtes au bon endroit.
                  <br /> <br />
                  <i className='inline-flex mt-2 text-white+ nodim unmute'>Regardez ce que nous avons fait.<br /> Imaginez ce que nous pouvons faire ensemble.</i>
                  <ImageMedia src={require('../assets/images/Signature_WebOnly.png')} className="!mix-blend-multiply !mr-auto w-52 !noaction !object-contain !pointer-events-none touch-none " />
                </span> */}

                <span className='maxW2'>
                  LAWWD — Look At What We Did — n’est pas simplement une agence de branding basée à Dakar. C’est un cabinet de stratégie et de création né d’une conviction forte : les marques africaines méritent des standards mondiaux, sans perdre leur authenticité.

                  <br /> <br />

                  Depuis le premier jour, notre mission est claire : structurer, révéler et amplifier les marques avec exigence et précision. Nous ne faisons pas “du design pour faire joli”. Nous construisons des systèmes de marque solides, pensés pour durer, évoluer et performer.

                  <br /> <br />

                  Identité visuelle, direction artistique, production photo & vidéo, expériences web et app, rendus 3D immersifs — chaque projet est abordé avec une approche stratégique. Nous analysons, nous questionnons, nous affinons. Puis nous créons.
                </span>

                <br />

                <span className='maxW2'>
                  Chez LAWWD, nous croyons que la créativité est plus puissante lorsqu’elle est structurée. Que le storytelling est plus impactant lorsqu’il est sincère. Et qu’une marque forte repose autant sur sa vision que sur son exécution.

                  <br /> <br />

                  Nous collaborons avec des entrepreneurs ambitieux, des institutions et des marques qui veulent élever leur image, clarifier leur positionnement et affirmer leur présence — au Sénégal, en Afrique et à l’international.

                  <br /> <br />

                  Si vous recherchez un partenaire stratégique capable de transformer votre vision en un univers cohérent, distinctif et maîtrisé, vous êtes au bon endroit.

                  <br /> <br />

                  <i className='inline-flex mt-2 text-white+ nodim unmute'>
                    Look At What We Did.<br />
                    Imagine What We Can Build Together.
                  </i>

                  <ImageMedia src={require('../assets/images/Signature_WebOnly.png')} className="!mix-blend-multiply !mr-auto w-52 !noaction !object-contain !pointer-events-none touch-none " />
                </span>
              </h4>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
};

// & WORLD MAP
/* const WorldMap = () => {

  const s = {
    title: "Working around the clock, Around the World",
    descr: ""
  }

  return (
    <Section padded className='gap-10'>
    <SectionTitle resp {...s} className="z-[2]" />
      <MotionProgress
        id='landingHome'
        height={100}
        offset="'start end', 'end end'"
        className='relative overflow-clip'>
        <div className='absolute flex justify-center items-center w-[100vw] h-[100vh] aspect-auto'>
          <ImageMedia src={img_earth} title='earth' className='relative z-[0] aspect-auto full mix-blend-screen object-center object-cover' />
          {zones.map((zone, i) => { return <Locator key={'locator' + i} {...zone} /> })}
        </div>
      </MotionProgress>
    </Section>
  )
}

const Locator = ({ id, size, ...props }) => {
  switch (size) {
    case 'large': size = { px: 54, vh: 7 }
      break
    default: size = { px: 44, vh: 4 }
  }
  return (
    <motion.button
      id={'locator' + id}
      style={{
        width: size.vh + 'vh',
        height: size.vh + 'vh',
        x: props.pin.x + 'vw',
        y: props.pin.y + 'vh'
      }}
      className={twMerge('left-0 z-[2] absolute inset-0 lg:flex hidden= rounded-full transition-all duration-[1s] aspect-square fit ',
        props.groups.length > 2 && size === 'large'
      )}
    >
      <div className={`absolute inset-0 scale-[1.2] group-hover:scale-[1.3] quicker border border-white/50 rounded-full`} />
      <div className='relative flex rounded-full overflow-hidden center full'>
        <span className='absolute inset-0 bg-gradient-to-tr from-white/5 backdrop-blur-md= rounded-full' />
        <h4 className='relative flex font-thin md:font-light text-center center full'>{props.length || '1+'}</h4>
      </div>

      <div id="zones" className='absolute inset-x-0 inset-y-0 flex justify-start items-start ml-[125%] py-4 origin-left group'>
        <div className='flex flex-col justify-start items-start'>
          <p className='group-hover:text-white absolute inset-y-0 my-auto h-fit font-normal text-left text-sm transition group-hover:translate-x-1'>
            {props.label}
          </p>
          <div className='flex flex-col'>
            {props.groups.map((item, i) => (
              <div key={item + i}></div>
            ))}
          </div>
        </div>
      </div>
    </motion.button>
  )
} */

export const statsData = [
  /*   {
      label: 'client attention',
      type: 'image',
      src: people_stat1,
      transform: 'origin-top-right object-contain object-top scale-[1.5] '
    }, */
  {
    label: `Projets conclus`,
    suffix: "+",
    descr: "a descr for later",
    type: '',
    value: 120,
    cardColor: "hover:bg-[#15291F]"
  },
  {
    label: "Pays d'intervention",
    descr: "",
    type: '',
    value: 10,
    cardColor: "hover:bg-[#1C1529]"
  },
  {
    label: 'Satisfaction Clientèle',
    descr: "for later",
    type: 'percent',
    value: 98,
    cardColor: "hover:bg-[#291515]"
  },
  {
    label: "Livrables Produits",
    descr: "for later",
    type: '',
    value: 132000000,
    cardColor: "hover:bg-[#1C1529]"
  },
  /*   {
      label: "Talentueux Créatifs",
      descr: "",
      type: '',
      value: 7,
      cardColor: "hover:bg-[#1C1529]"
    }, */
  /*   {
      label: "Appui aux startups",
      descr: "for later",
      type: '',
      value: 95000000,
      cardColor: "hover:bg-[#282115]"
    }, */
  {
    label: 'Partenaires B2B',
    descr: "for later",
    type: '',
    value: 6,
    cardColor: "hover:bg-[#1C1529]"
  },
];

const Stats = () => {

  const imgRef = useRef(null);

  const [initCount, setInitCount] = useState(false);

  useLayoutEffect(() => {
    setTimeout(() => {
      setInitCount(true)
    }, 1000)
  }, []);


  // useMotionValueEvent(scrollYProgress, "change", (latest) =>  {console.log(latest)})

  return (
    <Section id={"Stats"} className={"bg-dark="} >

      {/* <SectionTitle {...s} id='stats' className={''} /> */}

      <div className='relative flex flex-col w-full pb-20 h-full  md:landscape:pb-0'>
        <div className='relative flex lg:flex-row flex-col w-full'>
          <div className='w-full relative flex min-h-[40vh] h-full md:landscape:min-h-[60vh] center overflow-clip'>
            <div className='flex flex-grow center h-full relative '>
              <MotionContent height={"h-[40vh] lg:h-[80vh]"}
                imgRef={imgRef}
                offsetRange={["start end", "end start"]}
                translateRange={["20%", "-30%"]}
                scaleRange={[1.4, 1]}
              // className='min-h-[40vh] max-h-[60vh] h-full md:landscape:absolute inset-0'
              >
                <ImageMedia bypass
                  key={"statsheroimage"}
                  src={img_contactca}
                  className="!absolute !inset-x-0 w-full h-[50vh] md:h-[70vh] lg:h-[100vh] md:landscape:scale-[120%] object-cover object-center"
                />
              </MotionContent>
            </div>

            {/* GRADIENTS */}
            <div className='hidden aria-hidden md:landscape:flex absolute inset-x-0 bg-gradient-to-t from-black h-[50%] bottom-0' />
            <div className='hidden aria-hidden md:landscape:flex absolute inset-x-0 bg-gradient-to-t from-black h-[50%] bottom-0' />

            <span className='SEE absolute inset-x-0  resp bottom-0==lg: top-0 right-0 py-4 paddingX uppercase font-mono tracking-tight !text-[.7rem] lg:text-xs lg:muted lg:dim hover:nodim select-none quick '>
              à date du 01/01/2025
            </span>
          </div>

          <div className='relative z-[1] lg:landscape:absolute resp lg:bottom-16 inset-x-0 flex flex-col w-full lg:landscape:flex-row md:landscape:gap-4 md:landscape:divide-x= max-sm:divide-y  divide-white/10'>
            {statsData.map((stat, i) => {
              return <StatItem key={stat + "_" + i} {...stat} i={i} initCount={initCount} />
            })}
          </div>
        </div>
      </div>
    </Section >
  )
};

export const StatItem = ({ initCount, i, css, type, ...props }) => {
  const { formattingFn } = useDisplayValue(type)
  const { duration, ease } = animA()

  const countUpRef = useRef(null);

  return (
    <div className={twMerge('relative h-fit flex-grow w-full group cursor-default', css, type)}>

      <div className={twMerge('relative flex flex-col'
      )}>

        {/* <div id="gradient" className='DESK z-[1] absolute inset-0 bg-gradient-to-tr from-white/5' /> */}

        <div className='flex flex-col p-4 lg:pl-0 w-full h-full quick relative max-lg:portrait:border-b border1'>

          {/*   // * TODO STAT TOGGLE FEATURES */}

          <div className='absolute top-8 right-2 opacity-0'>
            <button className='flex items-center rounded-3xl group overflow-clip'>
              {/* <span className='pl-3 muted hidden lg:group-hover:flex quick w-0 lg:group-hover:w-auto quick'>voir plus</span> */}
              <span className='flex center size-8 rounded-full'>
                <i className='-rotate-45 size-8 flex center ri-arrow-right-s-line' />
              </span>
            </button>
          </div>

          {(props.value !== null && props.value !== undefined) && (

            <motion.h1
              initial={{ opacity: 0, filter: "blur(3px)" }}
              animate={{ opacity: 1, filter: "blur(0px)" }}
              transition={{ duration, ease, delay: .1 }}
              viewport={{ once: true }}
              ref={countUpRef}
              className='relative tracking-tight min-h-12'>
              {initCount &&
                <CountUp key={props.label}
                  start={initCount ? props.value * 0.1 : 0}
                  end={props.value}
                  duration='2.5'
                  className='m-0 p-0'
                  scrollSpyOnce
                  enableScrollSpy
                  formattingFn={formattingFn}
                  useEasing
                />
              }

              {props.suffix && <span>{props.suffix}</span>}

            </motion.h1>
          )
          }
          <h4 className='flex text-left whitespace-pre-wrap leading-tight origin-top-left hover:opacity-100 -translate-y-2 dim muted group-hover:unmute quick'>
            {props.label}
          </h4>
        </div>
        {/*   <div className='group-hover:flex hidden p-6 pt-0 quick'>
              <div className='group-hover:h-full crelative flex line-clamp-3 w-full h-0 text-xs quicker'>
                <p>{props.descr}</p>
              </div>
            </div> */}
      </div>
      {/* } */}
    </div>
  )
};

const Brands = () => {
  return (
    <div className='w-full relative flex center bg-!black !mix-blend-screen'>
      <div className='flex flex-col items-start justify-start w-full resp'>
        <ImageMedia src={img_brands} alt="Brands" className="origin-top object-contain w-full" />
      </div>
    </div>
  )
};

export const LetsWork = () => {

  const imgRef = useRef(null);
  // const { onMobile } = useWindowSize();
  // const DeskPageMotion = !onMobile ? motion.div : "div" // DYNAMICALLY HANDLE MOTION WRAPPER

  return (
    <div className='relative flex flex-col h-[40vh] landscape:h-[400px] lg:min-h-[50vh]'>

      <div className='flex center full relative overflow-clip'>
        <MotionContent img={imgRef} translateRange={["-10%", "20%"]} className='bg-black= flex center flex-grow min-h-[40vh] max-h-[60vh] landscape:max-h-[400px]= h-full !absolute noaction inset-0'>
          <ImageMedia
            title={"Office"}
            src={img_office}
            className="relative md:landscape:scale-[130%] full opacity-60 noaction object-cover object-bottom !origin-bottom"
          />
        </MotionContent>
        <div className='flex flex-col center relative max-w-2xl paddingX noaction scale-90='>
          <MotionContent height={"h-fit"} imgRef={imgRef} scaleRange={[.9, 1.1]} translateRange={[0, 0]} className='flex center resp w-full max-lg:translate-y-[20%] !my-auto'  >
            <ImageMedia
              key={"imaginez_ensemble"}
              src={svg_ensemble}
              className="object-contain noaction scale-[95%] !h-full py-4 object-center"
            />
          </MotionContent>
        </div>
      </div>

      {/* // TODO ONBOARDING PROCESS  */}

      {/*  <div className='hidden ====== onBoarding bg-slate-200 text-black'>
        <div className='resp space-y-8'>
          <h2>Voici comment nous travaillons</h2>


        </div>
      </div> */}
    </div >
  )
};

export default Home;
